import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Compass, LogOut, Map, Sparkles } from "lucide-react";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isAdmin = Boolean(user && user.is_admin);

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="no-print sticky top-0 z-50 border-b border-black/5 backdrop-blur-xl bg-[#FDFBF7]/70 backdrop-saturate-150">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <Compass className="w-6 h-6 text-[#C8553D]" strokeWidth={1.75} />
          <span className="font-display text-xl sm:text-2xl tracking-tight">WanderlyMe</span>
        </Link>
        <nav className="flex items-center gap-1 sm:gap-2">
          <Link
            to="/features"
            data-testid="nav-features"
            className="px-3 sm:px-4 py-2 text-sm rounded-full hover:bg-[#F3EFE8] transition-colors"
          >
            How it works
          </Link>
          <Link
            to="/destinations"
            data-testid="nav-guides"
            className="px-4 py-2 text-sm rounded-full hover:bg-[#F3EFE8] transition-colors hidden sm:block"
          >
            Guides
          </Link>
          <Link
            to="/plan-with-us"
            data-testid="nav-plan-with-us"
            className="px-4 py-2 text-sm rounded-full hover:bg-[#F3EFE8] transition-colors hidden md:block"
          >
            Plan with us
          </Link>
          {user ? (
            <>
              <Link
                to="/plan"
                data-testid="nav-plan"
                className="px-3 sm:px-4 py-2 text-sm rounded-full hover:bg-[#F3EFE8] transition-colors flex items-center gap-1.5"
              >
                <Sparkles className="w-4 h-4" /> <span className="hidden sm:inline">Plan</span>
              </Link>
              <Link
                to="/trips"
                data-testid="nav-trips"
                className="px-3 sm:px-4 py-2 text-sm rounded-full hover:bg-[#F3EFE8] transition-colors flex items-center gap-1.5"
              >
                <Map className="w-4 h-4" /> <span className="hidden sm:inline">My Trips</span>
              </Link>
              {isAdmin && (
                <Link to="/admin" data-testid="nav-admin" className="px-3 sm:px-4 py-2 text-sm rounded-full hover:bg-[#F3EFE8] transition-colors">
                  Admin
                </Link>
              )}
              <button
                onClick={handleLogout}
                data-testid="nav-logout"
                className="ml-0.5 sm:ml-1 px-3 sm:px-4 py-2 text-sm rounded-full hover:bg-[#F3EFE8] transition-colors flex items-center gap-1.5"
              >
                <LogOut className="w-4 h-4" /> <span className="hidden sm:inline">Logout</span>
              </button>
            </>
          ) : (
            <Link
              to="/auth"
              data-testid="nav-signin"
              className="px-5 py-2 text-sm rounded-full bg-[#1A3B2B] text-[#FDFBF7] hover:bg-[#122a1f] transition-colors"
            >
              Sign In
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
};
